import type { ReactNode } from 'react'

import { Button, LoadingSpinner } from '@/shared/components'
import FilterIcon from '@/assets/icons/filter.svg'

type JobsReportShellProps = {
  chartAriaLabel: string
  chartTitle: string
  isLoading: boolean
  error: string | null
  onOpenFilters: () => void
  chart: ReactNode
  table: ReactNode
  filtersPanel: ReactNode
}

export const JobsReportShell = ({
  chartAriaLabel,
  chartTitle,
  isLoading,
  error,
  onOpenFilters,
  chart,
  table,
  filtersPanel,
}: JobsReportShellProps) => (
  <>
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between gap-3">
        <Button
          type="button"
          icon={FilterIcon}
          variant="secondary-light"
          className="self-start"
          onClick={onOpenFilters}
        >
          Filter
        </Button>
      </div>

      <section
        aria-label={chartAriaLabel}
        className="flex flex-col items-center gap-3 px-2"
      >
        {isLoading ? (
          <LoadingSpinner position="center" label="Loading chart" />
        ) : error ? null : (
          <>
            {chartTitle ? (
              <h2 className="max-w-4xl text-center text-lg font-semibold text-foreground">
                {chartTitle}
              </h2>
            ) : null}
            {chart}
          </>
        )}
      </section>

      {table}
    </div>

    {filtersPanel}
  </>
)
